<template>
<v-card flat width="100%">
    <v-card-title>
        {{title}}
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <!-- Dialog for confirm delete user -->
    <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
        <v-card>
            <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
            <v-card-actions v-if="dialogItem.confirmAction">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions v-else>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                <v-btn color="blue darken-1" text @click="actionDeleteItem">Yes</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- @click:row="goToMemberDetails" -->
    <v-data-table :headers="headers" :search="search" :items="userList" sort-by="startDateFormated" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading" @click:row="goToMemberEdit">
        <template v-slot:[`item.avatar`]="{ item }">
            <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                <img :src="item.pictureUrl" />
            </v-avatar>
            <v-avatar v-if="!item.pictureUrl" color="info" size="32" class="mr-2">
                <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
        </template>
        <template v-slot:[`item.startDate`]="{ item }">{{ item.startDateFormated }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">{{ item.endDateFormated }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon class="mr-2" @click="goToMemberEdit(item)" :href="getItemEditUrl(item)" title="Edit" v-if="loggedInUserId==owner || isCoach">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <!-- <v-btn icon class="mr-2" @click="dialogDeleteItem(item)" title="Delete" v-if="loggedInUserId==owner || isCoach">
                <v-icon>mdi-delete</v-icon>
            </v-btn> -->
            <v-btn icon class="mr-2" @click="goToMemberResult(item)" :href="getItemResultUrl(item)" title="Result">
                <v-icon>mdi-file-table-box-multiple-outline</v-icon>
            </v-btn>
            <v-btn icon class="mr-2" @click="goToMemberReport(item)" :href="getItemReportUrl(item)" title="Report">
                <v-icon>mdi-chart-bar</v-icon>
            </v-btn>
        </template>
        <template v-slot:[`item.status`]="{ item }">
            <v-chip v-if="item.status == 'cancel'" class="ma-2" x-small color="grey" text-color="white">
                Cancel
            </v-chip>
            <v-chip v-else-if="item.status == 'completed'" class="ma-2" x-small color="green" text-color="white">
                Complete
            </v-chip>
            <v-chip v-else-if="item.status == 'inprogress'" class="ma-2" x-small color="orange" text-color="white">
                In Progress
            </v-chip>
            <v-chip v-else-if="item.status == 'notPreTest'" class="ma-2" x-small color="red" text-color="white">
                PreTest
            </v-chip>
            <v-chip v-else-if="item.status == 'notPostTest'" class="ma-2" x-small color="red" text-color="white">
                PostTest
            </v-chip>
            <v-chip v-else class="ma-2" x-small>
                Not start
            </v-chip>
        </template>
    </v-data-table>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
import setProgramInfo from "../data/setProgramInfo";
import {
    mapGetters
} from "vuex";
export default {
    data() {
        return {
            titleDefault: 'Member List',
            headersDefault: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "สมาชิก",
                    value: "name",
                    cellClass: "pr-0",
                },
                {
                    text: "วันที่เริ่ม",
                    value: "startDate",
                    align: "center"
                },
                {
                    text: "OnSite",
                    value: "onsiteCount",
                    align: "center"
                },
                {
                    text: "การใช้งานแอพ",
                    value: "activityCount",
                    align: "center"
                },
                {
                    text: "สถานะ",
                    value: "status",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "วันที่จบโปรแกรม",
                    value: "endDate",
                    align: "center"
                },
                {
                    text: "Action",
                    value: "actions",
                    sortable: false,
                }
            ],
            search: "",
            options: {
                itemsPerPage: 20,
            },
            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to remove this user?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to remove this user?",
                deleteConfirmation: false,
                deletedItemId: null,
                deletedProgramId: null
            },
            editable: false,
            status: ''
        };
    },
    created() {
        this.id = this.$route.params.id;
        if (this.owner != this.loggedInUserId) {
            //delete this.headers[7];
        }
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessOrgAdmin"
        ]),
        loading() {
            return this.$attrs.loading;
        },
        exportData() {
            return this.$attrs.exportData;
        },
        startDate() {
            return this.$attrs.startDate;
        },
        startDateFormated() {
            return this.$attrs.startDateFormated;
        },
        endDate() {
            return this.$attrs.endDate;
        },
        endDateFormated() {
            return this.$attrs.endDateFormated;
        },
        userList() {
            return this.$attrs.userList;
        },
        owner() {
            return this.$attrs.owner;
        },
        isCoach() {
            return this.$attrs.isCoach || true;
        },
        headers() {
            return this.$attrs.headers != undefined ? this.$attrs.headers : this.headersDefault
        },
        title() {
            return this.$attrs.title != undefined ? this.$attrs.title : this.titleDefault
        }
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToMemberResult(item) {
            this.$router.push(this.getItemResultUrl(item));
        },
        getItemResultUrl(item) {
            if (this.$route.params.mod != undefined) {
                return `/program/${this.$route.params.mod}/view/${item.programId}/${item.uid}/result`;
            } else {
                return `${this.$route.fullPath}/view/${item.programId}/${item.uid}/result`;
            }
        },
        goToMemberReport(item) {
            this.$router.push(this.getItemReportUrl(item));
        },
        getItemReportUrl(item) {
            if (this.$route.params.mod != undefined) {
                return `/program/${this.$route.params.mod}/view/${item.programId}/${item.uid}/report/bmi`;
            } else {
                return `${this.$route.fullPath}/view/${item.programId}/${item.uid}/report/bmi`;
            }
        },
        goToMemberEdit(item) {
            this.$router.push(this.getItemEditUrl(item));
        },
        getItemEditUrl(item) {
            if (this.$route.params.mod != undefined) {
                return `/program/${this.$route.params.mod}/view/${item.programId}/${item.uid}/edit`;
            } else {
                return `${this.$route.fullPath}/view/${item.programId}/${item.uid}/edit`;
            }
        },
        goToMemberDetails(item) {
            if (!this.dialogItem.deleteConfirmation) {
                this.$router.push(this.getItemReportUrl(item));
            }
        },
        getItemMemberUrl() {
            if (this.$route.params.mod != undefined) {
                return `/program/${this.$route.params.mod}/user/${this.id}`;
            } else {
                return `${this.$route.fullPath}/user/${this.id}`;
            }
        },
        goToLinkMember() {
            this.$router.push(this.getItemMemberUrl());
        },
        // toSetMemberInfo(item) {
        //     this.$router.push(`${this.$route.params.mod} != undefined ? '/program/' + this.$route.params.mod : this.$route.fullPath}/member/${item.uid}`);
        // },
        // //delete
        dialogDeleteItem(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedProgramId = item.programId; //assign delete item id
            this.dialogItem.deletedItemId = item.uid; //assign delete item id

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteItem() {
            (async () => {
                await setProgramInfo({
                    action: 'delete'
                }, this.dialogItem.deletedProgramId, this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";

                this.dialogItem.deleteConfirmation = false;
                this.dialogItem.deletedProgramId = this.dialogItemDefault.deletedProgramId;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id

                //to reload page
                setTimeout(() => {
                    this.$emit('toCreateGroupOverview', {
                        isSubmit: true,
                        startDate: this.startDate,
                        endDate: this.endDate,
                        action: 'delete'
                    });
                }, "1000");
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.deletedProgramId = this.dialogItemDefault.deletedProgramId; //assign delete program id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },

    }
};
</script>
